import React, { useEffect } from 'react';
import RouteConstants from '../../constants/routeConstants';
import { Box } from '@mui/material';
import CustomTabs from '../../sharedcomponents/customTabs/customTabs';
import { useState, Downgraded } from '@hookstate/core';
import { useEventState } from '../../stores/eventStore';
import Settings from './settings';
import AppConstants from '../../constants/appConstants';
import Helper from '../../utility/helper';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import { NO_ACCESS_PERMISSION, FULL_PERMISSION } from '../../constants/Constant';
import UnauthorizedUI from '../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import Title from '../../sharedcomponents/title/title';
import TicketList from './ticketList';
import { useHistory } from "react-router-dom";

const AllStarTicket = () => {
    // console.log("Asdasd");
    const history = useHistory();
    const tabValue = useState(0);
    const eventState = useEventState();
    const [sentData, setSentData] = React.useState(null);
    const eventInfo = Helper.getStorage('eventInfo');

    const collectionTabs = useState([
        {
            label: 'Tickets',
            value: 0,
            component: TicketList,
            data: [],
        },
        {
            label: 'Settings',
            value: 1,
            component: Settings,
            data: [],
        },
    ]);
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [modPermission, setModPermission] = React.useState(null);

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        if (eventState && eventState.eventDetail.get()) {
            if (Helper.isAdminUser(userInfo) || Helper.isEventStaff(userInfo) || Helper.isEventAdmin(userInfo)) {
                setModPermission(FULL_PERMISSION);
            } else {
                const permissions = eventState.permissions
                    .attach(Downgraded)
                    .get();
                if (permissions && permissions.length > 0) {
                    setModPermission(
                        Helper.getModuleAccessPermission(permissions, 'ALLSTARTICKET')
                    );
                }
            }
        }
    }, [eventState]);

    const handleChange = (value) => {
        tabValue.set(value);
    };
    const getSentData = (data) => {
        setSentData(data);
    }



    return (
        <Box
            sx={{
                // p: 2,
                width: '100%',
            }}>
            <Box className='contentBox'>
                <Title title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                    AppConstants.EVENT_MODULES.ALL_STAR_TICKET)} />
                {
                    modPermission && modPermission == NO_ACCESS_PERMISSION ?
                        <UnauthorizedUI showLogout={false} />
                        :
                        <CustomTabs
                            snackBarProps={snackBarProps}
                            setSnackBarProps={setSnackBarProps}
                            value={tabValue.get()}
                            handleChange={handleChange}
                            data={collectionTabs.attach(Downgraded).get()}
                            modPermission={modPermission}
                            removeMargin={true}
                            getSentData={getSentData}
                            sentData={sentData}
                        />
                }
                {/* ) */}
                {/* ): null} */}
            </Box>
            {snackBarProps.openSnack && (
                <CustomizedSnackbars
                    {...snackBarProps}
                    onClose={() =>
                        setSnackBarProps({ ...snackBarProps, openSnack: false })
                    }></CustomizedSnackbars>
            )}
        </Box>
    )

}

export default {
    routeProps: {
        path: RouteConstants.All_STAR_TIKCET,
        component: AllStarTicket,
    },
    name: 'AllStarTicket',
};
